import React, { useState , useEffect } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import TotalCase from "../../../images/totalCase.svg";
import TotalOrange from "../../../images/total_orange.svg";
import RedCase from "../../../images/red_case.svg";
import TotalCart from "../../../images/total_cart.svg";
import TotalTrey from "../../../images/total_tray.svg";
import TotalKnifes from "../../../images/total_knifes.svg";
import TotalBowls from "../../../images/total_bowl.svg";
import Datatable from "../../../components/shared/datatable/Datatable";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import WashingModal from "./WashingModal";
import EmployeeHistory from "./EmployeeHistory";
import { useGetWashingSummaryQuery } from "../dashboard/ripeingDashboardApi";

// import { EditSvg } from "../../../svgFiles/EditSvg";
// import { useGetMorningEmployeeQuery } from "./washingApi.js";
// import { useGetEveningEmployeeQuery } from "./washingApi.js";

import {
  useGetEmployeeDataQuery,
  useRemoveEmployeeWorkDataMutation,
} from "./washingApi.js";


import Button from "../../../components/shared/buttons/button";

import CommonDeleteModal from "../../../components/shared/modalLayout/CommonDeleteModal";

import { toast } from "react-hot-toast";

import useTranslator from "../../../hooks/useTranslator.js";
import moment from "moment";
import { convertToUserTimezone, formatDateAndTime } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants.js";

const Washing = () => {
  const [addEmployee, setAddEmployee] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [empcolumns, setEmpColumns] = useState(null);
  const currentDate = convertToUserTimezone(null, "YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [history, setHistory] = useState(false);
  const [data, setData] = useState(null);

  // const filter = { date };

  const [filter, setFilter] = useState({});
  const [pageSize, setPageSize] = useState(3);
  const [page, setPage] = useState(1);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [employeeToDelete, setEmployeeToDelete] = useState(null);

  // const { data: morningData } = useGetMorningEmployeeQuery({
  //   page,
  //   "filter[date]": date,
  // });

  // const { data: morningDataHistory } = useGetMorningEmployeeQuery({ page });
  // const { data: eveningData } = useGetEveningEmployeeQuery({
  //   page,
  //   "filter[date]": date,
  // });

  // const { data: eveningDataHistory } = useGetEveningEmployeeQuery({ page });
  const { data: summaryData, refetch: refetchSummaryData } = useGetWashingSummaryQuery({date});


  // fetching record from api (Employee Data)
  const { 
          data: employeeData,
          isLoading,
          isFetching,
          isError,
          error,
          refetch: refetchEmployeeData 
        } = useGetEmployeeDataQuery({ 
          page,
          // pageSize,
          ...filter,
         });

  // Remove employee from work data
  const [removeEmployeeWorkData] = useRemoveEmployeeWorkDataMutation();

  const { _t } = useTranslator();


  //  handle add Employee Data along with their shift

  const handleAddCommonData = () => {
    setAddEmployee(true);
    setModalMode("assignEmployee");
    setSelectedEmployee(null);
    setShowModal(true);
  };

  const handleEdit = (employeeData) => {
    setAddEmployee(true);
    setModalMode("editEmloyeWork");
    setSelectedEmployee(employeeData);
    setShowModal(true);
  };

  const handleDelete = (employee) => {
    setEmployeeToDelete(employee);
    setShowConfirmationModal(true);
  };

  const cancelDelete = () => {
    setShowConfirmationModal(false);
    setEmployeeToDelete(null);
  };

  const confirmDelete = async () => {
    setShowConfirmationModal(false);
    try {
      if (employeeToDelete && employeeToDelete.id) {
        await removeEmployeeWorkData(employeeToDelete.id).unwrap();
        refetchEmployeeData();
      } else {
        toast.error(_t("please_select_employee_first", "Please select an employee first."));
      }
    } catch (error) {
      console.error("Delete Error:", error);
      toast.error(
        error?.data?.message || "Unable to delete the employee. Please try again."
      );
    } finally {
      setEmployeeToDelete(null);
    }
  };

  // Refetch data when filter changes

  useEffect(() => {
    refetchEmployeeData();
  }, [filter, refetchEmployeeData]);

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleDataSaved = () => {
    refetchEmployeeData();
    refetchSummaryData();
  };

  const listItems = [
    {
      label: _t("total_cases", "Total Cases"),
      value: summaryData?.data.total_cases,
      icon: TotalCase,
    },
    {
      label: _t("orange_cases", "Orange Cases"),
      value: summaryData?.data.orange_cases,
      icon: TotalOrange,
    },
    {
      label: _t("red_cases", "Red Cases"),
      value: summaryData?.data.red_cases,
      icon: RedCase,
    },
    {
      label: _t("yellow_cases", "Yellow Cases"),
      value: summaryData?.data.yellow_cases,
      icon: TotalCase,
    },
    {
      label: _t("total_carts", "Total Carts"),
      value: summaryData?.data.total_carts,
      icon: TotalCart,
    },
    {
      label: _t("total_treys", "Total Treys"),
      value: summaryData?.data.total_treys,
      icon: TotalTrey,
    },
  ];

  const commonColumns = [
    {
      label: _t("date", "Date"),
      accessor: "date",
      cell: ({ row }) => convertToUserTimezone(row.date),
    },
    {
      label: _t("total_employees", "Total Employee"),
      accessor: "emp_total",
    },
    { label: _t("orange_cases", "Orange Cases"), accessor: "orange_cases" },
    { label: _t("red_cases", "Red Cases"), accessor: "red_cases" },
    {
      label: _t("yellow_cases", "Yellow Cases"),
      accessor: "yellow_cases",
    },
    {
      label: _t("carts_label", "Carts"),
      accessor: "carts",
    },
    { label: _t("treys", "Treys"), accessor: "treys" },
    {
      label: _t("shift", "Shift"),
      accessor: "shift",
      cell: ({ row }) => <>{row.shift === 1 ? _t("Morning","Morning") : _t("Evening","Evening")}</>,
    },
    {
      label: _t("action", "Action"),
      accessor: "status",
      cell: ({ row }) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Button
            size="small"
            label={
              row.status != "washing_done"
                ? _t("edit", "Edit")
                : _t("view", "View")
            }
            className="borderRedBtn"
            onClick={() => {
              handleEdit(row);
            }}
          />
          <Button
            size="small"
            label={_t("delete", "Delete")}
            className="ml-2"
            onClick={() => handleDelete(row)}
          />
        </div>
      ),
    },
  ];
  
  return !history ? (
    <div>
      {addEmployee && (
        <WashingModal
          show={showModal}
          setShow={setAddEmployee}
          mode={modalMode}
          employee={selectedEmployee}
          refetchEmployeeData={refetchEmployeeData}
          onSuccess={handleDataSaved}
        />
      )}
      <div className="overview cmn_card mb-3">
        {/* <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">
            {_t("washing_title", "Washing Overview")}
          </h6>
          <DateSelector setDate={setDate} />
        </div> */}
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>

        <Datatable
          title={_t("employee_shift", "Employee Shift")}
          columns={commonColumns}
          tableData={
            employeeData?.data
              ? { ...employeeData.data, data: employeeData.data.data }
              : { data: [] }
          }
          page={page}
          buttons={[
            {
              label: _t("add_data", "Add Data"),
              onClick: handleAddCommonData,
              icon: PlusSvg,
            },
          ]}
          showCount={true}
          showPegination={true}
          showFilter={setFilter}
          showFilterButton={true}
          onPageChange={handlePageChange}
          filterModule="cleaning_filter"
          isLoading={isLoading || isFetching}
        />

      <CommonDeleteModal
        show={showConfirmationModal}
        handleClose={cancelDelete}
        title="Confirm Delete"
        message={`${_t(
          "sure_confirm_delete",
          "Are you sure you want to delete"
        )}`}
        onConfirm={confirmDelete}
        // isLoading={isDeleting}
      />
    </div>
  ) : (
    <div>
      <EmployeeHistory
        setShow={setHistory}
        modalMode={modalMode}
        columns={empcolumns}
        tableData={data}
      />
    </div>
  );
};

export default Washing;
